export const PromoteType = [
  { value: 'helloBar', label: 'هلوبار' },
  { value: 'sidePopup', label: 'گوشه‌نمای پنل' },
  { value: 'centerPopup', label: 'پیام گوشه سایت اصلی' },
  { value: 'onSite', label: 'روی پنل' }
];
